import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v3_add_designation = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/designation`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};

export const v3_designations = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/designation/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    });
};

export const v3_designation_visibility = async (designationId, visibility) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/designation/${designationId}`;
    return customAxios.patch(url, { visibility }, getAuthHeader()).then((res) => {
        return res.data;
    });
};

export const v3_edit_designation = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/designation`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    });
};
